@if ((models?.length || client.isCms) && !(isFacet && component?.showCarouselOnFacets === 'hide')) {
<div class="wrap-x wrap-l">
    @switch (showExperimentalVersion) {
    @case (true) {
    <p class="p-b p-t-6 p-l-4-s p-l-4-m"
       sizeClass="XL:h3, SM: h4"
       *iCms="'title' of component"></p>
    @if (models?.length) {
    <div class="wrap"
         [grid]="2"
         [gridColumnGap]="'5px'"
         [gridRowGap]="'5px'">
        @for (model of displayedModels; track trackById(index, model); let index = $index) {
        <product class="w-12"
                 [listPosition]="index + 1"
                 [model]="model"
                 [klevuRecommendationId]="klevuRecommendationId"
                 [hideSwatches]="component.carouselVariant === 'reduced_details'
                                              || component.carouselVariant === 'smaller_squares'
                                              || component.carouselVariant === 'smaller_squares_title'"
                 [hideDetails]="component.carouselVariant === 'smaller_squares'"
                 [hideBrandRange]="component.carouselVariant === 'reduced_details'"
                 [hideLabels]="component.carouselVariant === 'smaller_squares'
                                              || component.carouselVariant === 'smaller_squares_title'"
                 [showRangeCode]="component.carouselVariant === 'reduced_details'
                                              || component.carouselVariant === 'smaller_squares_title'"
                 [listName]="listData"
                 [sendTracking]="true">
        </product>
        }
    </div>
    }
    <div class="m-t-2 m-b-2 flex flex-justify-center">
        <button (click)="loadMoreModels()"
                [disabled]="models?.length < 12 || disabled"
                class="b-radius-max m-r-2 flex flex-justify-center flex-middle bg-col-51 p-a-2 carousel-button"
                type="button">
            <i class="icon-chevron-down col-11 fs-3 inline-flex"
               aria-hidden="true">
            </i>
        </button>
    </div>
    }
    @default {
    @if(component.carouselVariant === 'new_in') {
    <div [grid]="client.sizeId > 1 ? 6 : 3"
         [gridColumnGap]="'0px'"
         [gridRowGap]="'0px'">
        @for (model of filteredModels; track trackById(index, model); let index = $index) {
        <product class="w-12"
                 [listPosition]="index + 1"
                 [model]="model"
                 [klevuRecommendationId]="klevuRecommendationId"
                 [klevuTypeId]="klevuTypeId"
                 [hidePrice]="component.carouselVariant === 'new_in'"
                 [klevuRecommendationId]="klevuRecommendationId"
                 [klevuTypeId]="klevuTypeId"
                 [hideSwatches]="true"
                 [hideDetails]="true"
                 [hideLastXRemainingBanner]="true"
                 [hideBrandRange]="true"
                 [hideLabels]="true"
                 [hideWishlist]="true"
                 [listName]="listData"
                 [sendTracking]="true"></product>
        }
    </div>
    } @else {
    <div class="flex flex-justify-between wrap p-l-0 p-r-0-s p-r-0-m p-r-0-l">
        <h2 class="p-b p-t-6 p-l-4-s p-l-4-m"
            sizeClass="XL:h3, SM: h4"
            *iCms="'title' of component"></h2>
        <div class="flex m-t-6 p-r-10-l p-r-4-s p-b-5 p-r-4-m z-1 swiper-nav-buttons">
            <button class="b-radius-max m-r-2 flex flex-justify-center flex-middle swiper-nav-button"
                    [ngClass]="'item-prev-' + uid"
                    type="button"
                    [attr.aria-label]="'Previous slide' | translate">
                <i class="icon-chevron-left col-6 fs-3 inline-flex"
                   aria-hidden="true">
                </i>
            </button>
            <button class="b-radius-max flex flex-justify-center flex-middle swiper-nav-button"
                    [ngClass]="'item-next-' + uid"
                    type="button"
                    [attr.aria-label]="'Next slide' | translate">
                <i class="icon-chevron-right col-6 fs-3 inline-flex"
                   aria-hidden="true">
                </i>
            </button>
        </div>
    </div>
    <carousel class="w-12 p-b-7 p-l p-l-0-l p-l-0-x product-carousel"
              [ngClass]="(component.carouselVariant === 'smaller_squares' || component.carouselVariant === 'smaller_squares_title') ? 'smaller-squares' : ''"
              [slidesPerView]="'auto'"
              [spaceBetween]="20"
              [loop]="false"
              [navigation]="{
                                    nextEl: '.item-next-' + uid,
                                    prevEl: '.item-prev-' + uid
                                }">
        @for (model of filteredModels; track trackById(index, model); let index = $index) {
        <ng-template swiperSlide
                     class="p-b-0">
            <product class="w-12"
                     [listPosition]="index + 1"
                     [model]="model"
                     [klevuRecommendationId]="klevuRecommendationId"
                     [klevuTypeId]="klevuTypeId"
                     [hideSwatches]="component.carouselVariant === 'reduced_details'
                                              || component.carouselVariant === 'smaller_squares'
                                              || component.carouselVariant === 'smaller_squares_title'"
                     [hideDetails]="component.carouselVariant === 'smaller_squares'"
                     [hideBrandRange]="component.carouselVariant === 'reduced_details'"
                     [hideLabels]="component.carouselVariant === 'smaller_squares'
                                              || component.carouselVariant === 'smaller_squares_title'"
                     [showRangeCode]="component.carouselVariant === 'reduced_details'
                                              || component.carouselVariant === 'smaller_squares_title'"
                     [listName]="listData"
                     [sendTracking]="true">
            </product>
        </ng-template>
        }
    </carousel>
    }

    }
    }
</div>
}